import { vdkEmHappinessPortalApi } from "./vdk-em-happiness-portal-api";
const uploadExcel = (file, eventId) => {
    const formData = new FormData();
    formData.append('File', file);
    formData.append('EventId', eventId);
    return vdkEmHappinessPortalApi.post('/tickets/upload-excel', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};
const downloadExcelTemplate = () => {
    return vdkEmHappinessPortalApi.get('/tickets/download-excel-template', {
        responseType: 'blob'
    });
};
const getAllTickets = (request) => {
    return vdkEmHappinessPortalApi.post('/tickets/get-all', request);
};
const assignTicketManually = (request) => {
    return vdkEmHappinessPortalApi.post('/tickets/assign-ticket-manually', request);
};
const assignTicketFromDatabase = (request) => {
    return vdkEmHappinessPortalApi.post('/tickets/assign-tickets', request);
};
const UnassignTicket = (request) => {
    return vdkEmHappinessPortalApi.put(`/tickets/unassign-tickets/${request}`);
};
const getRelationForTicket = (request) => {
    return vdkEmHappinessPortalApi.post('/tickets/get-relations', request);
};
const sendTicketEmail = (request) => {
    return vdkEmHappinessPortalApi.post('/tickets/send-email', request);
};
const sendBulkTicketEmail = (request) => {
    return vdkEmHappinessPortalApi.post('/tickets/send-email-bulk', request);
};
const uploadTicketDocument = (request) => {
    const formData = new FormData();
    formData.append('File', request.file);
    formData.append('EventId', request.eventId);
    if (request.ticketNo !== undefined) {
        formData.append('TicketNo', request.ticketNo.toString());
    }
    if (request.venueSection) {
        formData.append('VenueSection', request.venueSection);
    }
    if (request.venueSectionRow) {
        formData.append('VenueSectionRow', request.venueSectionRow);
    }
    if (request.venueSectionSeat) {
        formData.append('VenueSectionSeat', request.venueSectionSeat);
    }
    if (request.description) {
        formData.append('Description', request.description);
    }
    if (request.ticketType) {
        formData.append('TicketType', request.ticketType);
    }
    return vdkEmHappinessPortalApi.post('/ticketdocuments/upload', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};
const TicketsApi = {
    uploadExcel,
    downloadExcelTemplate,
    getAllTickets,
    assignTicketManually,
    assignTicketFromDatabase,
    UnassignTicket,
    getRelationForTicket,
    sendTicketEmail,
    sendBulkTicketEmail,
    uploadTicketDocument
};
export default TicketsApi;
